import { useState } from 'react';

import { useAuth } from './AuthenticationContext.jsx';

export default function SignOutButton() {
  const { signOut } = useAuth();
  const [pending, setPending] = useState(false);

  const handleClick = async () => {
    setPending(true);
    try {
      await signOut();
      // signOut flips `authenticated`, re-gating the app and unmounting this
      // button, so there is no post-success state update.
    } catch {
      // A failed sign-out leaves the user signed in; re-enable so they can retry.
      setPending(false);
    }
  };

  return (
    <button
      type="button"
      className="btn-secondary"
      onClick={handleClick}
      disabled={pending}
    >
      {pending ? 'Logging out…' : 'Logout'}
    </button>
  );
}
